import { Link } from 'react-router-dom';
import { novels } from '@/mocks/novels';

export default function LatestUpdates() {
  const latest = [...novels].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-2">紧跟每日更新，不错过任何精彩章节</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latest.map((novel) => (
            <Link
              key={novel.id}
              to={`/article/${novel.id}`}
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-14 h-20 md:w-16 md:h-22 flex-shrink-0 rounded overflow-hidden">
                <img
                  src={novel.coverImage}
                  alt={novel.title}
                  title={novel.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {novel.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">
                  {novel.author} · 共{novel.chapters}章
                </p>
                <div className="flex items-center gap-2 mt-2">
                  <span className="text-[11px] text-accent-500 bg-accent-50 px-2 py-0.5 rounded-full">
                    更新于 {novel.updateDate}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}